import { api } from './index'; // Import the base API

export const updateEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    updateDestination: builder.mutation({
      query: (destination) => {
        // Your existing code for the API request
        return {
          url: `destinations/${destination.destinationId}`,
          method: "PUT",
          body: destination.data,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
      ],
    }),

    updateAdventure: builder.mutation({
      query: (adventure) => {
        // Your existing code for the API request
        return {
          url: `adventures/${adventure.adventureId}`,
          method: "PUT",
          body: adventure.data,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminAdventureList", id: "AdminAdventureList" },
      ],
    }),

    updateProgramme: builder.mutation({
      query: (programme) => {
        // Your existing code for the API request
        return {
          url: `programmes/${programme.programmeId}`,
          method: "PUT",
          body: programme.data,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),

    updateProgrammePrices: builder.mutation({
      query: (programme) => {
        // Your existing code for the API request
        return {
          url: `programmes/prices`,
          method: "PUT",
          body: programme,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),

    updateDestinationImage: builder.mutation({
      query: (image) => {
        // Your existing code for the API request
        return {
          url: `images/${image.imageId}`,
          method: "PUT",
          body: image.data,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
        { type: "DestinationImages", id: "DestinationImages" },
      ],
    }),

    addProgrammeImage: builder.mutation({
      query: (programme) => {
        // Your existing code for the API request
        console.log(programme);
        const formData = new FormData();
        formData.append("DisplayImage", programme.displayImage); // must match DTO property name
        return {
          url: `programmes/${programme.id}/display-image`,
          method: "PUT",
          body: formData,
          // headers: {
          //   "Content-Type": "application/json",
          // },
        };
      },
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),
  }),
  overrideExisting: false,
});



export const {
  useUpdateDestinationMutation,
  useUpdateAdventureMutation,
  useUpdateProgrammeMutation,
  useAddProgrammeImageMutation,
  useUpdateDestinationImageMutation,
  useUpdateProgrammePricesMutation
  // ... export other hooks ...
} = updateEndpoints;

